import React from 'react';
import { useSelector } from 'react-redux';
import { Breakpoint } from '../../utilities/ui-utilities';

export const SmallListerTitle = () => {
	const { pageTitle, pages: { TotalItemCount } = {} } = useSelector(
		(state) => state
	);

	if (!TotalItemCount || !pageTitle) {
		return null;
	}

	return (
		<h1
			className="text-title pb-4 px-2 pt-4"
			data-testid="lister-main-title-small">
			<span itemProp="numberOfItems">{TotalItemCount}</span> {pageTitle}
		</h1>
	);
};

export const LargeListerTitle = () => {
	const { pageTitle } = useSelector((state) => state);

	if (!pageTitle) {
		return null;
	}

	return (
		<h1 className="text-display mb-5" data-testid="lister-main-title-large">
			{pageTitle}
		</h1>
	);
};

export const ListerTitle = () => {
	return (
		<React.Fragment>
			<Breakpoint.BelowSmallOnly>
				<SmallListerTitle />
			</Breakpoint.BelowSmallOnly>
			<Breakpoint.SmallAndAbove>
				<LargeListerTitle />
			</Breakpoint.SmallAndAbove>
		</React.Fragment>
	);
};

export default ListerTitle;
